module.exports = __webpack_public_path__ + "img/hero-1.c2918c4f.png";